import { VehicleRevenue } from "@/interfaces";
import api from "@/lib/axios";
import { DefaultGetRequestParams, DefaultResponse } from "./types";

interface VehicleRevenueInput {
  vehicle_id: number;
  category_id?: number | null;
  invoice_number?: string | null;
  date: string;
  amount: number;
  observations?: string | null;
}

export const vehicleRevenueService = {
  async index({
    page,
    per_page,
    search,
    filters = {},
  }: DefaultGetRequestParams) {
    const response = await api.get<DefaultResponse<VehicleRevenue>>(
      "/vehicle_revenue",
      { params: { page, per_page, search, ...filters } },
    );
    return response.data;
  },

  async create(data: VehicleRevenueInput) {
    const response = await api.post("/vehicle_revenue", data);
    return response.data;
  },

  async show(id: number) {
    const response = await api.get<DefaultResponse<VehicleRevenue, false>>(
      `/vehicle_revenue/${id}`,
    );
    return response.data;
  },

  async update(id: string | number, data: VehicleRevenueInput) {
    const response = await api.put(`/vehicle_revenue/${id}`, data);
    return response.data;
  },

  async destroy(id: number) {
    const response = await api.delete(`/vehicle_revenue/${id}`);
    return response.data;
  },
};
